export default __webpack_public_path__ + "img/caret-down-white.bf9a98d5.svg";